import {Subject} from "rxjs/Subject";
import {ReplaySubject} from "rxjs/ReplaySubject";

export class ServicesSubject<T> {
    needRefresh: boolean = true;
    subject: Subject<T> = new ReplaySubject<T>();
    data: T;
}